import ReactiveWidget from "lib/reactiveWidget";

import $              from "jquery"
import select2        from "select2"
import "select2/dist/css/select2.min.css"
import "select2-bootstrap-theme/dist/select2-bootstrap.min.css"

class ItemDocumentFormsWidget extends ReactiveWidget {
  bind() {
    bindFormActions.call(this)
    bindCheckbox.call(this)
    bindDropDown.call(this)
  }

  render() {
  }
}

let bindCheckbox = function() {
  this.root.on('click', 'input[name="document[included_in_annexure]"]', (e) => {
    let container = $(e.currentTarget).parents('.item-document-container')
    let fieldContainer = container.find('.annexure-fields')
    let fields = fieldContainer.find('input, select')

    if (e.currentTarget.checked) {
      fieldContainer.removeClass('d-none')
      fields.attr('disabled', false)
    } else {
      fieldContainer.addClass('d-none')
      fields.attr('disabled', true)
    }
  })
}

let bindDropDown = function() {
  this.root.on('change', '#document_stamp', (e) => {
    let container = $(e.currentTarget).parents('.item-document-container')

    let stampFieldContainer = container.find('.stamp-fields')
    let stampFields = stampFieldContainer.find('input, select')

    let receivedAtFieldContainer = container.find('.received-at-fields')
    let receivedAtFields = receivedAtFieldContainer.find('input, select')

    if (['certificate', 'details_noted'].includes(e.currentTarget.value)) {
      stampFieldContainer.removeClass('d-none')
      stampFields.attr('disabled', false)
    } else {
      stampFieldContainer.addClass('d-none')
      stampFields.attr('disabled', true)
    }

    if (e.currentTarget.value === 'received') {
      receivedAtFieldContainer.removeClass('d-none')
      receivedAtFields.attr('disabled', false)
    } else {
      receivedAtFieldContainer.addClass('d-none')
      receivedAtFields.attr('disabled', true)
    }
  })
}

let bindFormActions = function() {
  this.root.on('click', '.document-panel input[type="submit"]', (e) => {
    e.preventDefault();
    e.stopPropagation();
    const verb = e.currentTarget.value
    const type = {
      "reject": "warning",
      "approve": "success"
    }[verb.toLowerCase()]

    swal({
      title: `${verb} Uploaded Document`,
      html: "Are you sure?",
      type: type,
      showCancelButton: true,
      confirmButtonText: 'Yes',
      confirmButtonClass: 'btn btn-success margin-right',
      cancelButtonClass: 'btn btn-darkgrey',
      buttonsStyling: false
    }).then((confirm) => {
      if (confirm.value === true) {
        let container = $(e.currentTarget).parents('.item-document-container')
        let form      = $(e.currentTarget).parents('form')
        let action    = $(e.currentTarget).attr('formaction')
        let requestData      = form.serializeArray()
        $.ajax({
          url: action,
          type: form.attr('method'),
          dataType: 'json',
          data: requestData,
          beforeSend: () => {
            $(container).css('opacity', 0.5);
          },
          success: (data) => {
            const $container = this.root.find(`.item-document-container[document-id="${data.document_id}"]`)
            $container.fadeOut(300, () => {
              $container.remove()
              maybeShowItemDocumentsEmptyState(this.root)
            })
          },
          error: (xhr, text, error) => {
            swal({
              title: "Oops.",
              html: "There were some errors. Please review below",
              type: "warning",
              showCancelButton: true,
              confirmButtonText: `Done`,
            })

            let container = this.root.find(`.item-document-container[document-id="${xhr.responseJSON.document_id}"]`)[0]
            let partial = xhr.responseJSON.formHtml
            $(container).replaceWith(partial)
            $('body').trigger('form:rerender')
          }
        });
      }
    })
  });
}

function maybeShowItemDocumentsEmptyState($root) {
  const $list = $root.find("#item-documents-pending-list")
  if (!$list.length) return
  if ($list.find(".item-document-container").length === 0) {
    $list.addClass("d-none")
    $root.find("#item-documents-empty-state").removeClass("d-none")
  }
}

export default ItemDocumentFormsWidget
